import React from 'react';
import './index.css';
import {  Routes, Route } from "react-router-dom";
import BreatheLife from './pages/BreatheLife';
import NotFound from './components/NotFound';
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<BreatheLife/>} />
        <Route path="*" element={<NotFound />} />
      </Routes>

    </div>
  );
}

export default App;